import type { RequisiteType } from './api';

export type FiatCurrency = 'RUB' | 'KGS' | 'KZT';
export type TypicalMethod = 'mobile_tjs' | 'card' | 'sbp' | 'sbp_kgs' | 'rub_transgran_uzs_emission_tbank' | 'rub_transgran_uzs_emission_vtb' | 'rub_transgran_uzs_emission_sber' | 'transgran_card_rub_arm' | 'transgran_mobile_rub_arm' | 'kzt_transgran_gel' | 'kzt_transgran_idr' | 'kzt_transgran_tjs' | 'kzt_transgran_uzs' | 'elqr' | `kzt_transgran_with_comission_${'gel' | 'idr' | 'tjs' | 'uzs'}`;

export const resolveMerchantFiatCurrency = (user?: {
    fiat_currency?: FiatCurrency;
    integration_profile?: string;
} | null): FiatCurrency =>
    user?.fiat_currency || (user?.integration_profile === 'typical_v2_2' ? 'KGS' : 'RUB');

export const filterTypicalMethods = (
    methods: RequisiteType[],
    currency: FiatCurrency,
    operation: 'deposit' | 'withdraw'
): TypicalMethod[] => {
    const allowed = currency === 'KZT'
        ? operation === 'deposit' ? ['kzt_transgran_gel', 'kzt_transgran_idr', 'kzt_transgran_tjs', 'kzt_transgran_uzs'] : []
        : currency === 'KGS'
        ? operation === 'deposit' ? ['card', 'sbp_kgs', 'elqr'] : ['card', 'sbp_kgs']
        : operation === 'deposit'
            ? ['card', 'sbp', 'mobile_tjs', 'rub_transgran_uzs_emission_tbank', 'rub_transgran_uzs_emission_vtb', 'rub_transgran_uzs_emission_sber', 'transgran_card_rub_arm', 'transgran_mobile_rub_arm']
            : ['card', 'sbp'];
    const base = methods.filter(method => allowed.includes(method));
    return currency === 'KZT' && operation === 'deposit'
        ? base.flatMap(method => [method, method.replace('kzt_transgran_', 'kzt_transgran_with_comission_')]) as TypicalMethod[]
        : base as TypicalMethod[];
};

export const typicalPhonePlaceholder = (currency: FiatCurrency) =>
    currency === 'KGS' ? '+996700123456' : currency === 'KZT' ? '+77001234567' : '+79990000000';

export const buildTypicalCommonPayload = (values: {
    orderId: string;
    amount: number;
    currency: FiatCurrency;
    method: TypicalMethod;
    customerAccountId?: string;
    callbackUrl: string;
}) => ({
    order_id: values.orderId,
    amount: values.amount,
    currency: values.currency,
    method: values.method,
    ...(values.customerAccountId?.trim()
        ? { customer_account_id: values.customerAccountId.trim() }
        : {}),
    callback_url: values.callbackUrl,
});
